import React from "react";
import "./pageTitle.css";

const PageTitle = ({ title = "title here", className = "" }) => {
  return <p className={`page-title ${className}`}>{title}</p>;
};

export default PageTitle;



// WEBPACK FOOTER //
// ./src/components/common/PageTitle.jsx